<template>
  <a v-if="link"
     @click="$emit('click', {e: $event, link})"
     :href="link"
     class="product-title">
    <p class="product-title__title block-ellipsis block-ellipsis-truncate" :title="title" v-html="title"></p>
  </a>
  <div v-else class="product-title">
    <p class="product-title__title block-ellipsis block-ellipsis-truncate" :title="title" v-html="title"></p>
  </div>
</template>

<script>
export default {
  name: 'ProductTitle',
  props: {
    link: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped lang="sass">

.product-title
  display: block

.product-title__title
  margin: 10px 0
  -webkit-box-orient: vertical
  -webkit-line-clamp: 3
  color: $text-color
  font-weight: 400
  font-size: 14px
  line-height: 17px

  +mmin($tablet)
    height: 34px
    -webkit-line-clamp: 2

.product-card .product-title__title
  margin: 10px 0 5px

.product-card--adaptive-main-page .product-title__title
  +mmax(768)
    min-height: 51px

.product-card--simple-card .product-title__title
  max-height: 34px
  -webkit-line-clamp: 2

.products-with-video__product-info-wrap .product-title__title
  -webkit-box-orient: vertical
  -webkit-line-clamp: 2
  color: $text-color
  font-weight: 400
  font-size: 14px
  margin: 0 0 5px

</style>
